var exports = {
  "Qs": "xe533113f--6fe097--content",
  "d5": "xe533113f--6fe097--head",
  "AS": "xe533113f--6fe097--item",
  "jf": "xe533113f--6fe097--child",
};

module.exports = exports;
